"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findGatewayToken = void 0;
const tslib_1 = require("tslib");
/**
 * This wrapper module is needed so we can stub the functions in solana-gateway-ts
 * without running into the 'Descriptor for property is non-configurable and non-writable' error.
 */
const gatewayTs = tslib_1.__importStar(require("@identity.com/solana-gateway-ts"));
exports.findGatewayToken = gatewayTs.findGatewayToken;
